import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import { useMessageContext } from "../../../../../providers";

import { Task } from "../../../../../types/task";
import { Results } from "../../../../../types/subtask";

import { documentsFetcher } from "../../../../../services/api";

import {
  downloadFileHidden,
  generateRandomId,
} from "../../../../../utils/common";

import DeleteTaskButton from "../../../../Buttons/DeleteTaskButton";

import styles from "../../columns.module.css";
import ReuploadButton from "../../../../Buttons/ReuploadButton";

const ActionRow = ({ task }: { task: Task }) => {
  const { sendMessage } = useMessageContext();

  const getSubtaskId = async (
    messageId: string,
    downloadType: "ALL" | "FRDP",
    onlyResults = false
  ) => {
    const message = `La tasca anonimitzada "${task.name}" s'està preparant per descarregar. Si us plau, espera uns segons.`;

    try {
      sendMessage(message, "loading", 0, messageId);
      const { subtask_id } =
        await documentsFetcher.startProcessDownloadDocuments(
          task.id,
          onlyResults
        );
      return subtask_id;
    } catch (error) {
      sendMessage(
        "Hi ha hagut un error descarregant el document, si us plau, torna a intentar-ho més tard",
        "error",
        1.5,
        messageId
      );
    }
  };

  const downloadDocument = async (
    intervalId: NodeJS.Timer,
    subtaskId: string,
    messageId: string,
    downloadType: "ALL" | "FRDP"
  ) => {
    try {
      const { subtask, results } = await documentsFetcher.getDownloadDocuments(
        task.id,
        subtaskId
      );

      if (subtask.status === "SUCCESS") {
        const { url, filename } = results as Results;
        await downloadFileHidden(url, filename);
        const message = `El document anonimitzat "${task.name}" s'ha descarregat correctament`;
        sendMessage(message, "success", 1.5, messageId);
        clearInterval(intervalId);
      } else if (subtask.status === "FAILED") {
        throw Error("Subtask status failed");
      }
    } catch (error) {
      sendMessage(
        "Hi ha hagut un error descarregant el document, si us plau, torna a intentar-ho més tard",
        "error",
        1.5,
        messageId
      );
      clearInterval(intervalId);
    }
  };

  const onDownloadDocuments = async (downloadType: "ALL" | "FRDP") => {
    const messageId = generateRandomId();
    const onlyResults = downloadType === "FRDP";
    let intervalId: NodeJS.Timer | undefined;
    try {
      const subtask_id = await getSubtaskId(
        messageId,
        downloadType,
        onlyResults
      );
      intervalId = setInterval(
        () =>
          downloadDocument(
            intervalId as NodeJS.Timer,
            subtask_id as string,
            messageId,
            downloadType
          ),
        10000
      );
    } catch (error) {
      sendMessage(
        "Hi ha hagut un error descarregant el document, si us plau, torna a intentar-ho més tard",
        "error",
        1.5,
        messageId
      );
      clearInterval(intervalId);
    }
  };

  return (
    <div className={styles.tableRowActions}>
      {task.status === "SUCCESS" && (
        <>
          <Tooltip title="Descarregar arxiu">
            <Button 
              icon={<DownloadOutlined />} 
              onClick={() => onDownloadDocuments("FRDP")}
            />
          </Tooltip>
        </>
      )}
      {(task.status === "SUCCESS" || task.status === "FAILED") && (
        <DeleteTaskButton task={task} />
      )}
      {(task.status === "FAILED" || task.status === "CANCELLED") && (
        <ReuploadButton task={task} />
      )}
    </div>
  );
};

export default ActionRow;
